import { render, staticRenderFns } from "./PortionsConfiguration.vue?vue&type=template&id=7b338a2f&"
import script from "./PortionsConfiguration.vue?vue&type=script&lang=js&"
export * from "./PortionsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PortionsConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports